module.exports = __webpack_public_path__ + "static/media/3.309353f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.mp3
// module id = KdyI
// module chunks = 1